export const assetTypeConstant = [
    { name: "Primary", value: "primary" },
    { name: "Additional", value: "additional" },
  ];
  